import React from "react";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/home/Footer";
import HireHero from "../components/hire/HireHero";
import HireServices from "../components/hire/HireServices";
import HireWhyChooseUs from "../components/hire/HireWhyChooseUs";
import HireContactOptions from "../components/hire/HireContactOptions";
import NeedHelpChoosing from "../components/hire/NeedHelpChoosing";

const Jobs = () => {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Navbar />
      <HireHero />
      <HireServices />
      <HireWhyChooseUs />
      <NeedHelpChoosing />
      <HireContactOptions />      
      <Footer />
    </div>
  );
};

export default Jobs;